export default __webpack_public_path__ + "static/media/hero-4-bg.7670fff6.png";